export const LOAD_FEEDS = "LOAD_FEEDS";
export const LOADING_FEEDS = "LOADING_FEEDS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
